import "./Footer.css"

const Footer = ({ language }) => {
  const translations = {
    en: {
      brand: "BICHI FIRST",
      about: "About",
      aboutText:
        "Representing Bichi Federal Constituency with dedication and commitment to development.",
      contact: "Contact Info",
      address: "No. 11, Katsina Road, Bichi Town, Bichi LGA",
      phone: "08135403288",
      email: "abubakar.abubakar@nass.gov.ng",
      quickLinks: "Quick Links",
      copyright:
        "© 2025 Hon. Abubakar Kabir Abubakar Bichi. All rights reserved.",
    },
    ha: {
      brand: "BICHI FARKO",
      about: "Game da Mu",
      aboutText: "Wakilin Mazabar Bichi da himma da sadaukarwa ga ci gaba.",
      contact: "Bayanan Tuntuɓa",
      address: "Lamba 11, Titin Katsina, Garin Bichi, Karamar Hukumar Bichi",
      phone: "08135403288",
      email: "abubakar.abubakar@nass.gov.ng",
      quickLinks: "Hanyoyin Sauri",
      copyright:
        "© 2025 Malam Abubakar Kabir Abubakar Bichi. Duk haƙƙoƙin an kebe.",
    },
  }

  const t = translations[language]

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            {t.brand} <span className="checkmark">✓</span>
          </div>
          <p>{t.aboutText}</p>

          <div className="social-links">
            <div className="social-item">
              <a
                href="https://www.facebook.com/profile.php?id=100063653736192"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/facebook.png" alt="Facebook" />
              </a>
              <div className="social-label">Facebook</div>
            </div>

            <div className="social-item">
              <a
                href="https://www.instagram.com/hon_abubakar_bichi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/instagram.png" alt="Instagram" />
              </a>
              <div className="social-label">Instagram</div>
            </div>

            <div className="social-item">
              <a
                href="https://www.tiktok.com/@honabubakarkabirabubakar?_t=ZS-904NjxMC7N4&_r=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/tiktok.png" alt="TikTok" />
              </a>
              <div className="social-label">TikTok</div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        
      </div>
    </footer>
  )
}

export default Footer
